export const scanLevels = {
    INITIAL_STATES: 0,
    NFC_STARTED: 1,
    NFC_COMMUNICATING: 2,
    NFC_DATA_LENGTH:3,
    NFC_READING_STARTED: 4,
    NFC_READING: 5,
    NFC_FINISHED_OK: 6,
    SENDING_TO_SERVER: 7,
    REPORT_SUCCESSED: 8
}
export const dateCorrectionLevels = {
    INITIAL_STATES: 0,
    CORRECTION_REQUIRED: 1,
    CORRECTION_DATE_OK:2,
    CORRECTION_DATE_FAILED:3
}

export const supportNfLevels = {
    INITIAL_STATES: 0,
    NFC_NOT_SUPPORTED: 1,
    NFC_NOT_ENABLED:2,

}
